/**
 * Created by qingzhui on 17/1/1.
 */

require('../../scss/m/m-index.scss');

require('../../img/mobile/m-detail-img1.jpg');

var common = require('./m-common');

var $ = require('jquery');


function resizeIFrameToFitContent( iFrame ) {
//  console.log('reisze frame');
    if (!iFrame.contentWindow.document.body) {
        return;
    }

    // iFrame.width  = iFrame.contentWindow.document.body.scrollWidth;
    iFrame.height = iFrame.contentWindow.document.body.scrollHeight + 40;
    let iframeDoc = iFrame.contentDocument || iFrame.contentWindow.document;

    let images = iframeDoc.getElementsByTagName("img");
    for (let img of images) {
        img.style.maxWidth = "600px"; 
    }

}

$(function(){
    // 获取当前语言环境
    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();

    // 请求的所有地址
    var ajaxUrl = {
        newListType: baseUrl + 'v1/newstype' // 分类型新闻数据查询接口
    };

    var $tag = $('.tag'),
        tagValue = $tag.data('tag');

    $.ajax({
        url: ajaxUrl.newListType,
        type: 'get',
        dataType: 'json',
        data: {},
        success: function (data) {
            if (data.status) {
                // 成功进行回调
                var records = data.records;

                records.forEach(function(value){
                    if(value.code == tagValue){
                        var tag = lang === 'en' ? value.en : value.zh;
                        $tag.text(tag);
                        return;
                    }
                });
            } else {
                // 错误，打印返回的数据分析情况
                console.log(data);
            }
        }
    });

    setInterval(function() {
        resizeIFrameToFitContent($('#article-frame')[0]);
    }, 1000);
});



// WEBPACK FOOTER //
// ./src/m/m-details.js